var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.1V3.31666C18.3333 2.14166 17.8 1.66666 16.475 1.66666H13.1083C11.7833 1.66666 11.25 2.14166 11.25 3.31666V7.09166C11.25 8.275 11.7833 8.74166 13.1083 8.74166H16.475C17.8 8.75 18.3333 8.275 18.3333 7.1Z",
    fill: "#8B909A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 16.475V13.1083C18.3333 11.7833 17.8 11.25 16.475 11.25H13.1083C11.7833 11.25 11.25 11.7833 11.25 13.1083V16.475C11.25 17.8 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8 18.3333 16.475Z",
    fill: "#8B909A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75032 7.09996V3.31663C8.75032 2.14163 8.21699 1.66663 6.89199 1.66663H3.52533C2.20033 1.66663 1.66699 2.14163 1.66699 3.31663V7.09163C1.66699 8.27496 2.20033 8.74163 3.52533 8.74163H6.89199C8.21699 8.74996 8.75032 8.27496 8.75032 7.09996Z",
    fill: "#8B909A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75032 16.475V13.1083C8.75032 11.7833 8.21699 11.25 6.89199 11.25H3.52533C2.20033 11.25 1.66699 11.7833 1.66699 13.1083V16.475C1.66699 17.8 2.20033 18.3333 3.52533 18.3333H6.89199C8.21699 18.3333 8.75032 17.8 8.75032 16.475Z",
    fill: "#8B909A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.e93675a1a07b499fd8fcbb32eff3a513.svg";
export { ForwardRef as ReactComponent };